var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconQuickSelection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.001,
    height: 16,
    viewBox: "0 0 7.001 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Lighting_icon",
    "data-name": "Lighting icon",
    d: "M4326.571,1442.314l-5.664,9.066h3.594l-1.431,6.934,4.839-8.973H4324.5Z",
    transform: "translate(-4320.907 -1442.314)",
    fill: "#7f8283"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuickSelection);
export default __webpack_public_path__ + "static/media/icon_quick-selection.95cfb8f6.svg";
export { ForwardRef as ReactComponent };